module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_train-bdaac8d4c5a9fdb320454316edde29f3.svg";